import { useCallback } from "react";
import toast from "react-hot-toast";

import { useCurrentUser } from "@/contexts";
import { useScopedNavigate } from "@/hooks";
import { PlatformId } from "@/types/platform.types";
import { CurrentUser } from "@/types/user.types";
import { isTournatedPlatform } from "@/utils/uspa-utils/uspa-platform-utils";

const useFederationRedirect = () => {
  const navigate = useScopedNavigate();
  const currentUser = useCurrentUser();

  const checkAndRedirect = useCallback(
    (platformId: PlatformId | null, user: CurrentUser | null | undefined) => {
      if (!platformId || !user) return;

      if (isTournatedPlatform(platformId) && user?.role === "federation") {
        toast.error("You have no access for tournated platform");
        navigate("/");
      }
    },
    [navigate]
  );

  const IsSuperAdmin = useCallback(() => {
    if (currentUser.role !== "superAdmin") {
      navigate("/");
    }
  }, [currentUser.role, navigate]);

  return { checkAndRedirect, IsSuperAdmin };
};

export default useFederationRedirect;
